<app-orcamento-pdf></app-orcamento-pdf>

<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Vendas do Cliente <span class="text-muted fs-5">#{{ clienteId }}</span></h1>
    <button class="btn btn-secondary" (click)="voltar()">
      <i class="bi bi-arrow-left me-1"></i> Voltar
    </button>
  </div>
  <hr />

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID Venda</th>
          <th scope="col">ID Orcamento</th>
          <th scope="col">Data da Venda</th>
          <th scope="col">Total</th>
          <th scope="col">Saldo Devedor</th>
          <th scope="col">Forma de Pagamento</th>
          <th scope="col">Bandeira</th>
          <th scope="col">Parcelas</th>
          <th scope="col">Previsão de Entrega</th>
          <th scope="col">Status</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let venda of paginatedVendas">
          <th scope="row">{{ venda.idVenda }}</th>
          <td>{{ venda.idOrcamento }}</td>
          <td>{{ formatarData(venda.dataVenda) }}</td>
          <td>{{ venda.totalVenda | currency:'BRL':'symbol':'1.2-2' }}</td>
          <td>{{ venda.saldoDevedor | currency:'BRL':'symbol':'1.2-2' }}</td>
          <td>{{ venda.formaPagamento }}</td>
          <td>{{ venda.bandeiraCartao || '-' }}</td>
          <td class="text-center">{{ venda.numParcelas }}x</td>
          <td>{{ formatarData(venda.previsaoEntrega) }}</td>
          <td>
            <span class="badge"
              [class.bg-success]="venda.statusVenda === 'PAGO'"
              [class.bg-warning]="venda.statusVenda === 'PARCELADO'"
              [class.bg-danger]="venda.statusVenda === 'PENDENTE'"
              [class.bg-secondary]="venda.statusVenda !== 'PAGO' && venda.statusVenda !== 'PARCELADO' && venda.statusVenda !== 'PENDENTE'">
              {{ venda.statusVenda }}
            </span>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-info btn-sm"
              [disabled]="!venda.idOrcamento || imprimindoId === venda.idOrcamento"
              (click)="imprimirEspelho(venda.idOrcamento)">
              {{ imprimindoId === venda.idOrcamento ? 'Aguarde...' : 'Espelho' }}
            </button>
          </td>
        </tr>
        <tr *ngIf="vendas.length === 0">
          <td colspan="11" class="text-center text-muted py-4">Nenhuma venda encontrada para este cliente.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
    </ul>
  </nav>
</div>
